import { ThemeComponent } from "@/theme/ThemeComponent";
import { html, render } from "lit-html";
import { cart } from "@/theme/Cart";
import { CartItem, Component, dump, Prop, Ref } from '@eastsideco/salvo-ts';
import { QuantitySpinner } from "../QuantitySpinner/QuantitySpinner";
import { formatPrice} from "@/utils/products";
import { isTemplateExpression } from "typescript";


@Component
export class CartItemRow extends ThemeComponent {
    private quantity: QuantitySpinner;
    private loading: boolean = true;

    constructor(item: CartItem, quantity: QuantitySpinner, strings: string) {
        super();
        this.quantity = quantity;
        this.render(item, quantity, strings);

    }

    removeLoading() {
        this.classList.remove('cart-item-loading');
        this.loading = false;
    }

    setLoading() {
        this.classList.add('cart-item-loading');
        this.loading = true;
    }

    render(item: CartItem, quantity: QuantitySpinner, strings: string) {

        // Setup the purchase type for subscription products
        const properties = [];
        let upsellProduct = null;
        let upsellProductDiscount = null;
        let upsellPrice = null;
        const isFreeGift = item.properties && item.properties['_eligibleProductId'];
        const featureArray = [];
        let features = [];
        let productType = null;

        if (item.properties) {

            const properties_array = Object.entries(item.properties);
            const display_quantity = properties_array.find((property) => property[0] == '_display_quantity');
            const display_quantity_text = display_quantity ? display_quantity[1] : '';
            const pack_name = display_quantity && display_quantity[1] == '1' ? 'box' : 'boxes';
            const unit_type = properties_array.find((property) => property[0] == 'shipping_interval_unit_type');
            const hide_qty = properties_array.find((property) => property[0] == '_hide_qty');
            const unit_type_text = unit_type ? `${unit_type[1]}` : '';
            const rebuy = properties_array.find((property) => property[0] == '_source');
            const rebuy_type = rebuy ? String(rebuy[1]).toLowerCase() : null;

            for (const [key, value] of properties_array) {
                if (
                    key === 'shipping_interval_frequency' &&
                    display_quantity_text &&
                    pack_name &&
                    unit_type_text
                ) {
                    properties.push(html`<div class="cart-row__purchase-type">
                                        ${String(JSON.parse(strings).subscriptionText)}:
                                        <span class="cart-row__purchase-frequency">
                                            ${String(JSON.parse(strings).deliveryFrequencyText)}
                                            ${value}
                                            ${unit_type_text}
                                        </span></div>`);

                    productType = 'subscription';
                }

                if (key == '_upsellDiscount') {
                    upsellProduct = value;
                }

                if (key == '_upsellDiscountAmount') {
                    upsellProductDiscount = value;
                }

                if (key === '_features') {
                    features = JSON.parse(value as string);
                }
            }

            if (rebuy_type === 'rebuy' && unit_type_text) {
                properties.push(html`
                    <div class="cart-row__purchase-type">
                        ${String(JSON.parse(strings).subscriptionText)}:
                        <span class="cart-row__purchase-frequency">
                            ${String(JSON.parse(strings).deliveryFrequencyText)}
                            ${item.properties['shipping_interval_frequency']}
                            ${unit_type_text}
                        </span>
                    </div>
                `);

                productType = 'subscription';
            }
        }

        if (features && features.length) {

            for (const feature of features) {
                if (feature.icon) {
                    featureArray.push(html`<li 
                        class="fs-11 fs-lg-12"
                    >
                        <img
                            src="${feature.icon}"
                            alt="Icon for ${feature.icon}"
                            class="mr-5"
                            loading="lazy"
                        >
                        ${feature.text}
                    </li>`);
                } else {
                    featureArray.push(html`<li 
                        class="fs-11 fs-lg-12" 
                    >
                        ${feature.text}
                    </li>`);
                }

            }
        }

        const subscriptionTemplate = html`<div class="cart-row__properties">${properties}</div>`;
        const oneTimeTemplate = html`<div class="cart-row__purchase-type">
                                        <span class="text-primary">One time</span>
                                    </div>`;

        const featureTemplate = html`<ul class="cart-row__bullets">${featureArray}</ul>`;

        /* eslint-disable */
        let removeTemplate = html`<div class="cart-row__info-bottom">
            <button 
                class="cart-row__remove meta" 
                data-ref="removeItem" 
                data-item="${item.variantId}"
            >   
                <svg width="15" height="15" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2"><path style="fill:none" d="M0 0h22v22H0z"/><clipPath id="a"><path d="M0 0h22v22H0z"/></clipPath><g clip-path="url(#a)"><path d="M19.398 0H2.616a.688.688 0 0 0-.688.687v3.297a.688.688 0 0 0 .688.687h.976l.619 15.005A2.406 2.406 0 0 0 6.617 22h8.766a2.406 2.406 0 0 0 2.406-2.324l.619-15.005h.976a.687.687 0 0 0 .688-.687V.687c0-.374-.3-.68-.674-.687Zm-4.015 20.625H6.631a1.035 1.035 0 0 1-1.032-1.004L4.97 4.671h12.073l-.615 14.95a1.035 1.035 0 0 1-1.045 1.004ZM3.303 3.296H18.71V1.375H3.303v1.921ZM9.408 7.82v8.873a.688.688 0 0 1-1.375 0V7.82a.688.688 0 0 1 1.375 0Zm4.572 8.873V7.82a.688.688 0 0 0-1.375 0v8.873a.688.688 0 0 0 1.375 0Z"/></g></svg>
                <span class="cart-row__remove-text">${JSON.parse(strings).remove}</span>
            </button>
        </div>`;
        /* eslint-enable */

        // Setup for the item image
        let image = null;
        let title = html`item.productTitle`;
        let productUrl = null;
        let callout = null;
        let displayQuantity = item.quantity;
        let imgUrl = null;

        if (item.image) {
            if (
                item.properties &&
                item.properties['_parent_product_url'] &&
                item.properties['_parent_product_url'] != ''
            ) {
                productUrl = item.properties['_parent_product_url'];
            } else {
                productUrl = item.url;
            }

            if (item.properties && item.properties['checkout_image']) {
                imgUrl = item.properties['checkout_image'];
            }else {
                imgUrl = item.image;
            }

            // If the product is a free gift, it will have an eligibleProductId property
            // in which case we can remove the link directly to the product

            if (isFreeGift) {
                title = html`${item.productTitle}`;
                image = html`<div class="cart-row__image">
                                <img src="${item.image}&width=210" alt="${item.title}" loading="lazy">
                            </div>`;
            } else {
                title = html`<a href="${productUrl}" class="cart-row__title-link">${item.productTitle}</a>`;
                image = html`<a href="${productUrl}" class="cart-row__image object-cover">
                    <img src="${imgUrl}&width=210" alt="${item.title}" loading="lazy">
                </a>`;
            }

        }

        if (
            item.properties &&
            item.properties['_display_quantity']
        ) {
            displayQuantity = item.quantity / Number(item.properties['_display_quantity']);
        }

        if (Number(upsellProductDiscount) > 0) {
            upsellPrice = item.linePrice - Number(upsellProductDiscount);
            const upsellDiscountMessage = JSON.parse(strings).upsellDiscountText;
            if (upsellDiscountMessage) {
                /* eslint-disable */
                callout = html`<div class="cart-row__callout">
                    <div>
                        <svg class="icon icon--tick-circle icon--xsmall" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2"><path style="fill:none" d="M0 0h22v22H0z"/><circle cx="11" cy="11" r="11" fill="#01b57a"/><path d="M18.613 5.703a1.182 1.182 0 0 0-1.68 0l-8.819 8.83-3.705-3.716a1.207 1.207 0 0 0-1.173-.293c-.416.119-.736.45-.877.87-.069.419.059.862.369 1.163l4.546 4.545c.222.224.524.35.84.35.316 0 .618-.126.875-.35l9.624-9.659a1.182 1.182 0 0 0 0-1.74Z" style="fill:#fff;fill-rule:nonzero"/></svg>
                    </div>
                    ${String(upsellDiscountMessage)}
                    </div>`;
                    /* eslint-enable */
            }
        }

        let price = html`${formatPrice(item.linePrice, String(JSON.parse(strings).moneyFormat))}`;

        if (upsellPrice && upsellPrice > 0) {
            price = html`${formatPrice(upsellPrice, String(JSON.parse(strings).moneyFormat))}
                <s class="text-raspberry ml-5">
                    ${formatPrice(item.linePrice, String(JSON.parse(strings).moneyFormat))}
                </s>`;
        }

        if (isFreeGift) {
            removeTemplate = html``;
        }

        // One-time products display a quantity spinner
        let quantityTemplate = html`<span class="cart-row__qty-label">Qty:</span> ${displayQuantity}`;
        if (
            productType != 'subscription' && !isFreeGift && !upsellPrice) {
            quantityTemplate = html`<span class="cart-row__qty-label">Qty:</span> ${quantity}`;
        }
        // revert condition if product contains _hide_qty which removes the selector...
        if (item?.properties != undefined || item?.properties != null ) {
            if (item?.properties['_hide_qty'] == 'true' || item?.properties['_hide_qty'] == true) {
                quantityTemplate = html`<span class="cart-row__qty-label">Qty:</span> ${displayQuantity}`;
            }
        }

        /* eslint-disable */
        render(html`
            <div class="cart-row" data-upsell-product="${upsellProduct || ''}" data-upsell-discount="${upsellPrice && upsellPrice > 0 ? 'true' : 'false' }">
                ${image}
                <div class="cart-row__information">
                    <div class="cart-row__info-top">
                        <div class="cart-row__title">
                            ${title}
                        </div>
                        ${featureArray.length ? featureTemplate : ''}
                    </div>
                    ${properties.length ? subscriptionTemplate : oneTimeTemplate}
                    <div class="cart-row__qty" data-id="${item.id}">
                        ${quantityTemplate}
                    </div>
                    <div class="cart-row__price">
                        ${price}
                    </div>
                    ${removeTemplate}
                </div>
            </div>
            ${callout ? callout : ''}
        `, this);
        /* eslint-enable */
    }

    @Ref({ required: false }) removeItem!: HTMLButtonElement;

    /**
     * Initialise.
     */
    init() {
        if (this.removeItem) {
            this.$listen(this.removeItem, 'click', () => this.handleRemoveItem(this.removeItem));
        }
        this.$subscribe(this.quantity.onChange, (value) => {
            this.setLoading();
            this.handleQuantity();
            setTimeout(() => {
                this.removeLoading();
            }, 1000);
        });
    }

    /**
     * Remove item from cart.
     * @param target - remove button.
     */
    handleRemoveItem(target: HTMLElement) {
        if (target.dataset.item === undefined) { return; }

        for (const item of cart.items) {
            if (~~item.id === ~~target.dataset.item) {
                try {
                    cart.removeItem(item).catch((event: unknown) => {
                        if (event instanceof Error) {
                            this.$log.error(event.message);
                        }
                    });

                } catch (event: unknown) {
                    if (event instanceof Error) {
                        this.$log.info('Remove error', event.message);
                    }
                }
            }
        }
    }

    /**
     * Handle cart quanitty Change.
     */
    handleQuantity() {
        if(this.quantity === null || this.quantity.parentNode === null ) { return; }

        if (this.quantity.parentNode instanceof HTMLElement) {
            if(this.quantity.parentNode.dataset.id == null) { return; }
            const itemId = this.quantity.parentNode.dataset.id;

            for (const item of cart.items) {

                if (+item.id === +itemId) {
                    const quantity = +this.quantity.input.value;

                    try {
                        cart.changeItem(item, quantity, null).catch((event: unknown) => {
                            if (event instanceof Error) {
                                this.$log.error(event.message);
                            }
                        });

                    } catch (event: unknown) {
                        const { message } = event as Error;
                        this.$log.info('Quantity error', message);
                    }
                }
            }
        }
    }
}

